import { FC, PropsWithChildren } from 'react'
import styled, { css } from 'styled-components'

import COLOR from '@/components/cell/designTokens/color'
import TYPOGRAPY from '@/components/cell/designTokens/typography'

type TextType =
  | 'title1'
  | 'title2'
  | 'title3'
  | 'title4'
  | 'description1'
  | 'description2'
  | 'caption1'
  | 'caption2'
  | 'caption3'

type TextElement = 'h1' | 'h2' | 'h3' | 'h4' | 'a' | 'span' | 'p' | 'address' | 'th' | 'td'

interface ContainerProps {
  $type: TextType
  $color: string
  $numberOfLines?: number
}

const Container = styled.span<ContainerProps>`
  margin: 0px;
  font-style: normal;
  color: ${(props) => props.$color};

  ${({ $numberOfLines }) =>
    $numberOfLines !== undefined &&
    $numberOfLines > 0 &&
    css`
      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${$numberOfLines};
    `}

  ${(props) => TYPOGRAPY[props.$type]}
`

export interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  type: TextType
  color?: string
  element?: TextElement
  numberOfLines?: number
  onClick?: () => void
}
const Text: FC<PropsWithChildren<Props>> = ({
  type,
  numberOfLines,
  color = COLOR.black,
  element = 'span',
  children,
  onClick,
  ...htmlDefaultProps
}) => {
  return (
    <Container
      as={element}
      $type={type}
      $color={color}
      $numberOfLines={numberOfLines}
      onClick={onClick}
      {...htmlDefaultProps}
    >
      {children}
    </Container>
  )
}

export default Text
